<template>
  <vc-layout justify-center
             @touchstart.capture="onTouchStart"
             @touchend.capture="onTouchEnd">
    <v-date-picker
      :first-day-of-week="firstDayOfWeek"
      data-qa="date-input"
      :showCurrent="showCurrent"
      :range="Array.isArray(this.value)"
      class="vc-date-input"
      ref="datePicker"
      color="var(--brand-color-secondary)"
      :width="width"
      no-title
      v-model="formattedValue"
      :pickerDate="pickerDate"
      @update:picker-date="handleChange"
      @click.native="onClick"
      :scrollable="scrollable"
      prev-icon="chevron_left"
      next-icon="chevron_right"
    >
    </v-date-picker>
  </vc-layout>
</template>

<script>
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  name: 'VcDateInput',
  data() {
    return {
      isRangeSet: false,
      currentHover: null,
      allNodes: [],
      focusMonth: null,
      tempValue: null,
      pickerDate: null,
      hasSwiped: false,
      startX: null,
      SWIPE_DISTANCE: 10,
    }
  },
  created() {
    if (!Array.isArray(this.value)) {
      this.pickerDate = moment(this.value).format('YYYY-MM');
    }
  },
  props: {
    value: {
      type: Array | Date,
      default: ['',''],
    },
    range: {
      type: Boolean,
      default: false,
    },
    showCurrent: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "292px",
    },
    firstDayOfWeek: {
      type: Number,
      default: 0,
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    currentHover(val) {
      if (this.computedValue.length !== 2) this.resetHover();
      if (this.computedValue.length == 1) {
        var addedCount = 0

        for (var i = 0; i < this.relevantDateElsArray.length; i++) {
          if (i === 0) {
            this.addStartSelection(i)
            continue;
          }
          if (i === this.relevantDateElsArray.length - 1){
            this.addEndSelection(i)
            continue;
          }
          this.addClass(i);
        }
      }
    },
    computedValue(val) {
      if(!this.range) {
        return
      }
      if (!val[0] && !val[1]) {
        this.resetHover()
        return
      }
      var self = this;

      self.allNodes = this.$refs.datePicker.$el.querySelectorAll("td .v-btn");

      var observer = new MutationObserver(function(mutations){
        for (var i=0; i < mutations.length; i++){
          if (i == mutations.length -1) {

            var headerText = this.$refs.datePicker.$el.querySelector(".v-date-picker-header__value button");
            if (headerText) {
              headerText = headerText.innerText;
              self.focusMonth = new Date(headerText).toLocaleDateString().split('/').reverse().join('-').substring(0,8);
            }
            self.initDateHoverEvent();
          }
        }
      });

      observer.observe(this.$refs.datePicker.$el.getElementsByClassName("v-picker__body")[0], {
        childList: true,
        subtree: true,
      });

      if (val.length === 1) {
        self.initDateHoverEvent();
      }
    },
  },
  computed: {
    ...mapGetters(['isSmallScreen']),
    relevantDateElsArray() {
      var fixedDate = moment(this.computedValue[0]).format('YYYY-MM-DD');
      var valueDate = this.getFloatingDate(fixedDate, this.currentHover);
      var hoverAhead = fixedDate < valueDate
      const earlyDate = hoverAhead ? fixedDate : valueDate
      const laterDate = hoverAhead ? valueDate : fixedDate

      const filtered = new Array(...this.allNodes).filter((date, index) => {
        const iDate = this.getFloatingDate(fixedDate, index + 1);
        return iDate >= earlyDate && laterDate >= iDate
      })
      const sorted = filtered.sort((a,b) => {
        const integerDateA = parseInt(a.innerText)
        const integerDateB = parseInt(b.innerText)
        return integerDateA >= integerDateB
      })
      return sorted
    },
    computedValue() {
      return this.tempValue || this.value
    },
    formattedValue: {
      get() {
        if (Array.isArray(this.value)) {
          return this.computedValue.map((date) => {
            return date ? moment(date).format('YYYY-MM-DD') : ''
          })
        } else {
          return this.value ? moment(this.value).format('YYYY-MM-DD') : ''
        }
      },
      set(val) {
        if (Array.isArray(this.value)) {
          if (this.range && val.length === 1) {
            this.tempValue = val
            return
          }
          this.tempValue = null;
          this.$emit('input', val.map(date => date ? new Date(date) : '').sort())
        } else {
          const [year, month, day] = val.split('-')
          this.$emit('input', val ? new Date(year, parseInt(month) - 1, day) : '')
        }
      }
    }
  },
  methods: {
    onTouchStart(e) {
      // store the start position of the touch event
      this.startX = e.touches[0].clientX;
    },
    onTouchEnd(e) {
      const touch = e.changedTouches[0];
      const deltaX = touch.clientX - this.startX;
      const distance = Math.sqrt(deltaX * deltaX);

      this.hasSwiped = distance > this.SWIPE_DISTANCE;
    },
    handleChange(val) {
      if (this.pickerDate === val) {
        return
      }
      if (this.isSmallScreen && this.$vuetify.rtl && this.hasSwiped) {
        const sign = moment(this.pickerDate).isBefore(val) ? 1 : -1
        val = moment(val).subtract(sign * 2, 'month').format('YYYY-MM')
      }
      this.hasSwiped = false;
      this.pickerDate = val
    },
    onClick() {

      if(!this.range) {
        return
      }
      if (this.isRangeSet && !this.computedValue[1]){
        this.resetHover()
        this.isRangeSet = false
      }
      else if (this.computedValue[0] && this.computedValue[1]) {
        this.isRangeSet = true
      }
    },
    addClass(i) {
      this.relevantDateElsArray[i].parentNode.classList.add("highlight__date");
      this.relevantDateElsArray[i].classList.add("highlight__date__btn");
    },
    addStartSelection(i) {
      this.relevantDateElsArray[i].parentNode.classList.add("highlight__start");
      this.relevantDateElsArray[i].classList.add("edge__start");
    },
    addEndSelection(i) {
      this.relevantDateElsArray[i].parentNode.classList.add("highlight__end");
      this.relevantDateElsArray[i].classList.add("edge__end");
    },
    resetHover() {
      for (var i = 0; i < this.allNodes.length; i++) {
        this.allNodes[i].parentNode.classList.remove("highlight__date");
        this.allNodes[i].classList.remove("highlight__date__btn");
        this.allNodes[i].parentNode.classList.remove("highlight__start");
        this.allNodes[i].parentNode.classList.remove("highlight__end");
        this.allNodes[i].classList.remove("edge__start");
        this.allNodes[i].classList.remove("edge__end");
      }
    },
    initDateHoverEvent () {
      var self = this;

      self.allNodes = this.$refs.datePicker.$el.querySelectorAll("td .v-btn");
      self.allNodes.forEach(function(node) {
        node.addEventListener("mouseover", function() {
          self.currentHover = node.innerText;
        });
      });
    },
    getFloatingDate(fixedDate, val) {
      var valueDate = val.toString().length == 1 ? "0" + val : val;

      var joinDate = this.focusMonth || fixedDate.substring(0, 8);
      return joinDate + valueDate;
    }
  }
}
</script>

<style lang="scss" scoped>

.vc-date-input ::v-deep {
  min-width: 100%;
  height: auto;
  .v-date-picker-table.v-date-picker-table--date {
    table {
      tbody {
        tr {
          td {
            button.v-btn {
              height: 32px;
            }
          }
        }
      }
    }

  }
  table{border-spacing: 0 10px}
  td.highlight__date{
    background-color: rgba(var(--brand-color-secondary-rgb) ,0.2);
    .v-btn{
      transition-property: background-color;
      background-color: unset!important;
      color: rgba(0, 0, 0, 0.87);
      &::before{background-color: unset}
    }

  }
  td.highlight__start {
    background: linear-gradient(to right, transparent 50%, rgba(var(--brand-color-secondary-rgb) ,0.2) 50%);
  }
  td.highlight__end {
    background: linear-gradient(to right, rgba(var(--brand-color-secondary-rgb) ,0.2) 50%, transparent 50%);
  }
  td.highlight__end, td.highlight__start{
    .v-btn{
      background-color: var(--brand-color-secondary);
      color: #FFFFFF;
    }
  }

  .v-btn{
    &.v-date-picker-table__current:not(.v-btn--active) {
      color: rgba(0, 0, 0, 0.87) !important;
      border: 2px solid var(--brand-color-secondary);
    }
    &:hover{
      background: rgba(0, 0, 0, 0.07);
      &::before{background-color: unset}
    }
  }
}

.vc-date-input.v-picker--date.v-picker {
  border-radius: 6px;
  box-shadow: unset;
  ::v-deep {
    .v-btn {
      &:hover {
        background: var(--v-secondary-base);
        color: #FFFFFF;
      }
    }
    .v-date-picker-header__value {
      font-family: var(--primary-font-family);
      font-size: 14px;
      color: rgba(3, 3, 3, 0.87);
    }
    .v-date-picker-table {
      height: unset;
      padding: 0 13px;
      padding-bottom: 14px;
      thead {
        font-family: var(--primary-font-family);
        line-height: 1.33;
      }
      tbody {
        font-family: var(--primary-font-family);
        tr {
          td {
            padding: 2px 3px;
            button  {
              div {
                font-weight: normal;
              }
            }
          }
        }
      }
    }
  }
}

</style>
